import { supabase } from './supabase';

export interface LeaderboardRecord {
  user_id: string;
  rank: number | null;
  total_sessions: number | null;
  total_duration: number | null;
  total_cycles: number | null;
  current_streak: number | null;
  best_streak: number | null;
  last_session_date: string | null;
}

export interface LeaderboardProfile {
  user_id: string;
  display_name: string | null;
  profile_name: string | null;
  display_profile: boolean | null;
  profile_picture_name: string | null;
}

/**
 * Fetch leaderboard rows ordered by rank. Defaults to top 25 entries.
 */
export async function listLeaderboardEntries(
  limit = 25
): Promise<LeaderboardRecord[]> {
  const { data, error } = await supabase
    .from('leaderboard')
    .select(
      'user_id, rank, total_sessions, total_duration, total_cycles, current_streak, best_streak, last_session_date'
    )
    .order('rank', { ascending: true, nullsFirst: false })
    .limit(limit);

  if (error) throw error;
  return (data as LeaderboardRecord[]) || [];
}

/**
 * Fetch profile preferences for a set of users so display names can be shown when allowed.
 */
export async function listLeaderboardProfiles(
  userIds: string[]
): Promise<LeaderboardProfile[]> {
  if (!userIds || userIds.length === 0) return [];

  const { data, error } = await supabase
    .from('user_settings')
    .select(
      'user_id, display_name, profile_name, display_profile, profile_picture_name'
    )
    .in('user_id', userIds);

  if (error) throw error;
  return (data as LeaderboardProfile[]) || [];
}
